import { Checkbox } from 'uikit';

import type React from 'react';
import { useCallback } from 'react';

import type { ITableLikeTreeFilterItem } from '../context';

interface ILeftFilterCheckHeader {
    checkedIds: number[];
    items: ITableLikeTreeFilterItem[];
    onCheckChange: (checked: boolean) => any;
    disabled?: boolean;
}

export const LeftFilterCheckHeader: React.FC<ILeftFilterCheckHeader> = (props) => {
    const { checkedIds, items, onCheckChange, disabled } = props;

    const onChange = useCallback(
        ({ checked }) => {
            onCheckChange(checked);
        },
        [onCheckChange],
    );

    return (
        <Checkbox
            disabled={disabled}
            intermediate={!!checkedIds.length && checkedIds.length !== items.length}
            checked={!!checkedIds.length && checkedIds.length === items.length}
            onChange={onChange}
            size="l"
        />
    );
};

LeftFilterCheckHeader.displayName = 'LeftFilterCheckHeader';
